import React from "react";
import B1 from "../../Assessts/Images/Gallery/Brochures/B1.png";
import B2 from "../../Assessts/Images/Gallery/Brochures/B2.png";
import B3 from "../../Assessts/Images/Gallery/Brochures/B3.png";
import B4 from "../../Assessts/Images/Gallery/Brochures/B4.png";

import { Row, Col } from "react-bootstrap";
import { Images } from "../../ReUableComponents/CommonElements";

const Brochures = () => {
  const YearBrochures = [
    { Img: B1, Name: "NSF - NCL Brochure" },
    { Img: B2, Name: "NSF – India Scholarships Brochure" },
    { Img: B3, Name: "NSF India Brochure" },
    { Img: B4, Name: "NSF - CBA Brochure" },
  ];

  const OPenPDF = (index) => {
    switch (index) {
      case 0:
        window.open(
          "./PDFS/Brouchers/NSF - NCL Brochure.pdf",
          "_blank",
          "noopener,noreferrer"
        );
        break;
      case 1:
        window.open(
          "../PDFS/Brouchers/NSF India - Scholarships Brochure.pdf",
          "_blank",
          "noopener,noreferrer"
        );
        break;
      case 2:
        window.open(
          "../PDFS/Brouchers/NSF - India Brochure.pdf",
          "_blank",
          "noopener,noreferrer"
        );
        break;
      case 3:
        window.open(
          "../PDFS/Brouchers/NSF - CBA Brochure.pdf",
          "_blank",
          "noopener,noreferrer"
        );
        break;
    }
  };
  return (
    <div className="m-4 Brouchures-Maindiv">
      <div className="Web-MainHeading mt-3 mb-3">Brochures</div>
      <div className="container-fluid">
        <Row className="dflex gap-2">
          {YearBrochures.map((item, index) => (
            <>
              <Col className="dflex flexd-column alignitems ">
                <div className="CPointer" onClick={() => OPenPDF(index)}>
                  <Images
                    Image={item.Img}
                    Name={item.Name}
                    SpanClass="Web-SubHeading"
                  />
                </div>
              </Col>
            </>
          ))}
        </Row>
      </div>
    </div>
  );
};
export default Brochures;
